export default {
  home: 'Home',
  studyPlan: 'Study Plan',
  curricularMesh: 'Curricular Mesh',
  matterDescription: 'Matter Description',
  evaluations: 'Evaluations',
  learningExperiences: 'Learning Experiences',
}
